import { render, staticRenderFns } from "./BrandPanelTypographyEdit.vue?vue&type=template&id=04af3748&"
import script from "./BrandPanelTypographyEdit.vue?vue&type=script&lang=ts&"
export * from "./BrandPanelTypographyEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports